import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'oktaGroupName',
})
export class OktaGroupNamePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    const parts = value.split('.');
    if (parts.length !== 3) return value; // fallback to original

    const [company, location] = parts;

    return `${company} (${location})`;
  }
}
